import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

/**
 * Dropdowns desta tela.
 *
 * Canais e equipes NÃO moram mais aqui: viviam com as chaves achatadas
 * `['channels-dropdown']` / `['teams-dropdown']` e colidiam com os hooks dos
 * módulos donos. Agora existe um dono só de cada:
 *   - canais  → `@/modules/channels/hooks/useChannelsDropdown` (`['channels','dropdown']`)
 *   - equipes → `@/modules/teams/hooks/useTeams`               (`['teams','dropdown']`)
 */

/**
 * Interface para dados de dropdown de provider
 */
export interface ProviderDropdownItem {
  id: string;
  name: string;
  type: string;
  logo?: string;
}

/**
 * Hook para buscar providers disponíveis para dropdown
 *
 * @param capabilities - Array de capabilities para filtrar (OR logic - qualquer match)
 * @param type - Tipo de provider (MESSAGING, PAYMENT, etc.)
 */
export const useProvidersDropdown = (
  capabilities?: string[],
  type?: 'MESSAGING' | 'PAYMENT'
) => {
  return useQuery({
    queryKey: ['provider', 'dropdown', capabilities, type],
    queryFn: async () => {
      const params = new URLSearchParams();

      if (capabilities && capabilities.length > 0) {
        params.append('capabilities', capabilities.join(','));
      }

      if (type) {
        params.append('type', type);
      }

      const queryString = params.toString();
      const url = queryString ? `/provider/dropdown?${queryString}` : '/provider/dropdown';

      const response = await api.get(url);
      return response.data.data as ProviderDropdownItem[];
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
